import { create } from 'zustand';

type PrV2ActiveFileStore = {
  activeFilenameByPr: Record<string, string | null>;
  setActiveFilename: (prKey: string, filename: string | null) => void;
  clearActiveFilename: (prKey: string) => void;
};

/**
 * Builds the stable per-PR key used by the active-file navigation store.
 */
export function getPrV2ActiveFileStoreKey(owner: string, repo: string, number: string): string {
  return `${owner}/${repo}/${number}`;
}

/**
 * Tracks the currently active filename per PR view.
 *
 * `clearActiveFilename` removes the PR key entirely (instead of setting null)
 * so stale entries do not accumulate across navigation.
 */
export const usePrV2ActiveFileStore = create<PrV2ActiveFileStore>((set) => ({
  activeFilenameByPr: {},
  setActiveFilename: (prKey, filename) =>
    set((state) => {
      if (state.activeFilenameByPr[prKey] === filename) {
        return state;
      }

      return {
        activeFilenameByPr: {
          ...state.activeFilenameByPr,
          [prKey]: filename,
        },
      };
    }),
  clearActiveFilename: (prKey) =>
    set((state) => {
      if (!(prKey in state.activeFilenameByPr)) {
        return state;
      }

      const nextActiveFilenameByPr = { ...state.activeFilenameByPr };
      delete nextActiveFilenameByPr[prKey];
      return {
        activeFilenameByPr: nextActiveFilenameByPr,
      };
    }),
}));
